import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from "@mui/material";

export default function DeleteRow(props) {
  return (
    <Dialog
      BackdropProps={{
        style: {
          // backgroundColor: "transparent",
        },
      }}
      PaperProps={{
        elevation: 1,
      }}
      fullWidth
      open={props.deleteState.show}
      onClose={() =>
        props.setDeleteState({ ...props.deleteState, show: false })
      }
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle color="red" id="alert-dialog-title">
        توجه!
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          آیا از حذف {props.type} {props.deleteState.name} اطمینان دارید ؟
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          sx={{ color: "#565656 !important" }}
          onClick={() => {
            props.callback();
            props.setDeleteState({ ...props.deleteState, show: false });
          }}
        >
          بله
        </Button>
        <Button
          color="secondary"
          onClick={() =>
            props.setDeleteState({ ...props.deleteState, show: false })
          }
        >
          خیر
        </Button>
      </DialogActions>
    </Dialog>
  );
}
